import { useState } from 'react';
import { Alert, Button, Form, InputGroup, Modal, Spinner } from 'react-bootstrap';
import { IMediaItem } from '../../../models/Interfaces';

export default function RenameMediaDialog({ file, onClose, onRename }: {
  file: IMediaItem;
  onClose: () => void;
  onRename: (filename: string) => Promise<void>;
}) {
  const dot = file.Filename.lastIndexOf('.');
  const extension = dot > 0 ? file.Filename.slice(dot) : '';
  const [name, setName] = useState(dot > 0 ? file.Filename.slice(0, dot) : file.Filename);
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState('');
  const valid = name.trim().length > 0 && name.trim().length + extension.length <= 200 &&
    !/[<>:"/\\|?*\u0000-\u001f\u007f]/.test(name) && !/[. ]$/.test(name.trim());
  return <Modal show centered onHide={() => { if (!busy) onClose(); }} backdrop={busy ? 'static' : true} keyboard={!busy} aria-labelledby="rename-media-title">
    <Modal.Header closeButton={!busy}><Modal.Title id="rename-media-title">Rename file</Modal.Title></Modal.Header>
    <Form onSubmit={async event => {
      event.preventDefault();
      if (!valid || busy) return;
      setBusy(true); setError('');
      try { await onRename(name.trim() + extension); }
      catch (e) { setError(e instanceof Error ? e.message : 'The file could not be renamed. Please retry.'); }
      finally { setBusy(false); }
    }}>
      <Modal.Body>
        {error && <Alert variant="danger">{error}</Alert>}
        <Form.Label htmlFor="rename-media-name">File name</Form.Label>
        <InputGroup>
          <Form.Control id="rename-media-name" autoFocus required maxLength={200 - extension.length} value={name} disabled={busy} onChange={event => setName(event.target.value)} aria-describedby="rename-media-help" />
          {extension && <InputGroup.Text>{extension}</InputGroup.Text>}
        </InputGroup>
        <Form.Text id="rename-media-help">Changes the name in your media library and downloads. The public URL stays the same, so existing pages keep working.</Form.Text>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" disabled={busy} onClick={onClose}>Cancel</Button>
        <Button type="submit" disabled={!valid || busy}>{busy && <Spinner animation="border" size="sm" className="me-2" />}{busy ? 'Renaming…' : 'Rename file'}</Button>
      </Modal.Footer>
    </Form>
  </Modal>;
}
